import { cpfValidator } from '../../../../utils/cpfValidation'

export const validateCPF = (value, translation, user) => {
  if (user?.national_id) {
    return true
  }

  return cpfValidator(value) || translation
}
